
var path = '/privacy-policy'

export default {
  head() {
    return {
      title: this.pageData.metatitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageData.metadesc,
        }
      ],
    }
  },

  data() {
    return {
      pageData: null,
    };
  },

  asyncData(context) {
    // var key = context.route.name
    // if (Object.keys(context.store.state.pages[key]).length) {
    //   return { pageData: context.store.state.pages[key] }
    // }

    return context.$axios
      .get(path)
      .then((res) => {
        // context.store.commit('savePageData', {
        //   page: context.route.name,
        //   data: res.data,
        //   locale: context.i18n.locale
        // })
        return { pageData: res.data }
      })

  },

}
